import React, { Component } from "react";
import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";
import PrivateRoute from "./components/helpers/PrivateRoute";
import Layout from "./components/layouts/Layout";
import { Home } from "./components/views/Home/Home";
import { Card } from "./components/views/Card/Card";
import { CardPdf } from "./components/views/Card/CardPdf";
import { Login } from "./components/views/Login/Login";
import { RecoverPassword } from "./components/views/Login/RecoverPassword";
import { Error404 } from "./components/views/Error/Error404";
import { Guidelines } from "./components/views/Guidelines/Guidelines.js";
import { Reports } from "./components/views/Reports/Reports";
import { Faq } from "./components/views/Info/Faq";
import { AboutUs } from "./components/views/Info/AboutUs";
import { FreeTrial } from "./components/views/Login/FreeTrial";

import { SavedSearchesManagement } from "./components/views/Account/SavedSearchesManagement";
import { PlaylistsManagement } from "./components/views/Account/PlaylistsManagement";
import { DailyUpdateManagement } from "./components/views/Account/DailyUpdateManagement";
import { MySubscription } from "./components/views/Account/MySubscription";
import { Letter } from "./components/views/Account/Letter";
import { UnSubscribe } from "./components/views/Account/UnSubscribe";

import CookiesModal from "./components/Micro/CookiesModal.js";

import "./scss/Config.scss";
import "./scss/Reset.scss";

export default class App extends Component {
  static displayName = App.name;

  constructor(props) {
    super(props);
    this.state = {
      sendToLogin: false,
      sendToHome: false,
      sendToCard: null,
    };
  }

  componentDidMount() {
    window.addEventListener("sendToLogin", this.sendToLoginEvent, false);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.sendToLogin !== this.state.sendToLogin) {
      this.setState({ sendToLogin: false });
    }
  }

  componentWillUnmount() {
    window.removeEventListener("sendToLogin", this.sendToLoginEvent, false);
  }

  sendToLoginEvent = () => {
    this.setState({ sendToLogin: true });
  };

  render() {
    return (
      <BrowserRouter>
        <CookiesModal />
        <Switch>
          <Route path="/login" render={(props) => <Login {...props} />}></Route>
          <Route path="/freeTrial">
            <FreeTrial />
          </Route>
          <Route path="/recoverPassword/:hash" render={(props) => <RecoverPassword {...props} />}></Route>
          <Route path="/unSubscribe/:idLetter/:idUser" render={(props) => <UnSubscribe {...props} />}></Route>
          {this.state.sendToLogin && <Redirect to="/login" />}

          <PrivateRoute exact path="/">
            <Layout>
              <Home />
            </Layout>
          </PrivateRoute>

          <PrivateRoute exact path="/card/:id">
            <Layout>
              <Card />
            </Layout>
          </PrivateRoute>

          <PrivateRoute exact path="/card-pdf/:id">
            <CardPdf />
          </PrivateRoute>

          <PrivateRoute exact path="/savedSearches">
            <Layout fullHeight={false}>
              <SavedSearchesManagement />
            </Layout>
          </PrivateRoute>

          <PrivateRoute exact path="/playlists">
            <Layout fullHeight={false}>
              <PlaylistsManagement />
            </Layout>
          </PrivateRoute>

          <PrivateRoute exact path="/dailyUpdate">
            <Layout fullHeight={false}>
              <DailyUpdateManagement />
            </Layout>
          </PrivateRoute>

          <PrivateRoute exact path="/letter/:id">
            <Layout fullHeight={false}>
              <Letter />
            </Layout>
          </PrivateRoute>

          <PrivateRoute exact path="/mySubscription">
            <Layout fullHeight={false}>
              <MySubscription />
            </Layout>
          </PrivateRoute>

          <PrivateRoute exact path="/reports">
            <Layout fullHeight={false}>
              <Reports />
            </Layout>
          </PrivateRoute>

          <PrivateRoute exact path="/faq">
            <Layout fullHeight={false}>
              <Faq />
            </Layout>
          </PrivateRoute>

          <PrivateRoute exact path="/aboutUs">
            <Layout fullHeight={false}>
              <AboutUs />
            </Layout>
          </PrivateRoute>

          {/* Components Documentation and Playground */}
          {window.location.hostname === "localhost" && (
            <Route path="/guidelines">
              <Guidelines />
            </Route>
          )}

          {/* Default Route on 404 */}
          <Route path="*">
            <Error404 />
          </Route>
        </Switch>
      </BrowserRouter>
    );
  }
}
